import { CREATE_ENTRY_STRATEGY, CREATE_ENTRY_STRATEGY_FAILED, CREATE_ENTRY_STRATEGY_SUCCESSFUL } from './actionTypes';

export const createEntryStrategy = (entryStrategy, history) => {
  return {
    type: CREATE_ENTRY_STRATEGY,
    payload: { entryStrategy, history },
  };
};

export const createEntryStrategySuccessful = (message) => {
  return {
    type: CREATE_ENTRY_STRATEGY_SUCCESSFUL,
    payload: message,
  };
};

export const createEntryStrategyFailed = (message) => {
  return {
    type: CREATE_ENTRY_STRATEGY_FAILED,
    payload: message,
  };
};
